<!--

	Clickable control with an arrow that changes direction
	depending on the expanded value.

-->

<template>
	<div class="mia-Expandable" @click.stop="onClick">
		<slot />
		<inline-svg
			src="@theme/icons/caret_down_icon.svg"
			class="mia-Expandable-icon"
			:class="{ 'mia-Expandable-icon--expanded': expanded }"
			aria-hidden="true"
		/>
	</div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch, toNative } from "vue-facing-decorator";
import InlineSvg from "vue-inline-svg";

@Component({
	components: {
		InlineSvg,
	},
	emits: ["update:modelValue"],
})
export class Expandable extends Vue {
	@Prop({ required: true, type: Boolean }) protected modelValue!: boolean;

	expanded = false;

	@Watch("modelValue", { immediate: true })
	private onSet(value: boolean) {
		this.expanded = value;
	}

	onClick() {
		this.expanded = !this.expanded;
		this.$emit("update:modelValue", this.expanded);
	}
}

export default toNative(Expandable);
</script>

<style lang="scss">

.mia-Expandable {
	cursor: pointer;

	.mia-Expandable-icon {
		width: theme.$mia-icon-size;
		height: theme.$mia-icon-size;
		flex-shrink: 0;
		margin: theme.$mia-margin-size;
		transition: transform 0.2s ease;
	}

	.mia-Expandable-icon--expanded {
		transform: rotate(180deg);
	}

	&:hover .mia-Expandable-icon {
		color: theme.$mia-color-buttonEncourage;
	}

	@media (min-width: theme.$screen-sm-min) {
		.mia-Expandable-icon {
			margin-left: theme.$mia-margin-size-xxl;
			margin-right: theme.$mia-margin-size-large;
		}
	}
}

</style>
